import * as libphonenumber from 'libphonenumber-js'
import { Keypair } from 'tokend-js-sdk'
import { validateAddress } from './address_validation'
import { i18n } from '@js/i18n'
import { CRYPTO_CURRENCYS } from '@utils/consts'
import CryptoJS from 'crypto-js'
import WAValidator from 'wallet-address-validator'

const BASE58_ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
const BASE58_REGEX = /^[1-9A-HJ-NP-Za-km-z]+$/
const TRON_VERSION = 0x41

const rules = [
  {
    name: 'phone_number',
    message: i18n.invalid_phone_number(),
    validate: value => libphonenumber.isValidNumber(libphonenumber.parse(value))
  },
  {
    name: 'strong_password',
    message: i18n.valid_password_az(),
    validate: value => {
      let isValid = true
      isValid = isValid && Boolean(value.match(/([a-z])/g))
      isValid = isValid && Boolean(value.match(/([0-9])/g))
      isValid = isValid && !(value.match(/([ ])/g))
      return isValid
    }
  },
  {
    name: 'account_id',
    message: i18n.valid_account_id(),
    validate: value => Keypair.isValidPublicKey(value)
  },
  {
    name: 'secret_key',
    message: i18n.valid_secret_key(),
    validate: value => Keypair.isValidSecretKey(value)
  },
  {
    name: 'email_or_account_id',
    message: i18n.valid_email_or_id(),
    validate: value => validateEmail(value) || Keypair.isValidPublicKey(value)
  },
  {
    name: 'amount',
    message: i18n.validate_amount_number(),
    validate: value => Number(value) && Number(value) > 0
  },
  {
    name: CRYPTO_CURRENCYS.BTC,
    message: i18n.invalid_wallet_address(),
    validate: value => validateAddress(value)
  },
  {
    name: CRYPTO_CURRENCYS.ETH,
    message: i18n.invalid_wallet_address(),
    validate: value => validateAddress(value)
  },
  {
    name: CRYPTO_CURRENCYS.USDTRC,
    message: i18n.invalid_wallet_address(),
    validate: value => validateTRC(value)
  },
  {
    name: CRYPTO_CURRENCYS.USDTERC,
    message: i18n.invalid_wallet_address(),
    validate: value => valideteBEPERC(value)
  },
  {
    name: CRYPTO_CURRENCYS.USDTBEP,
    message: i18n.invalid_wallet_address(),
    validate: value => valideteBEPERC(value)
  },
  {
    name: 'soft_cap',
    getMessage: (field, [cap]) => `Value should be bigger than soft cap: ${i18n.cc(cap)}`,
    validate: (value, [cap]) => +value >= +cap
  },
  {
    name: 'max_issuance',
    getMessage: (field, [max, code]) => `You cant sell more tokens than you have. Available: ${i18n.c(max)} ${code}`,
    validate: (value, [max]) => +value <= +max
  }
]

/**
 *
 * @param {object} validator - vee-validate validator object to add rules
 */
export function extendValidator (validator) {
  addCustomRulesToValidator(validator)
  return validator
}

/**
 *
 * @param {object} validator - vee-validate validator object to add rules
 */
function addCustomRulesToValidator (validator) {
  rules.forEach(rule => {
    validator.extend(rule.name, {
      getMessage: rule.getMessage || (_ => rule.message),
      validate: rule.validate
    })
  })
  return validator
}

function valideteBEPERC (address) {
  return WAValidator.validate(address, 'ETH')
}

function base58Decode (input) {
  const bytes = [0]

  for (const char of input) {
    const value = BASE58_ALPHABET.indexOf(char)
    if (value === -1) throw new Error('Invalid Base58 char')

    let carry = value
    for (let i = 0; i < bytes.length; i++) {
      carry += bytes[i] * 58
      bytes[i] = carry & 0xff
      carry >>= 8
    }

    while (carry > 0) {
      bytes.push(carry & 0xff)
      carry >>= 8
    }
  }

  // leading zero bytes
  for (const char of input) {
    if (char === '1') bytes.push(0)
    else break
  }

  return new Uint8Array(bytes.reverse())
}

function toWordArray (u8) {
  return CryptoJS.lib.WordArray.create(u8)
}

function isValidChecksum (decoded) {
  const payload = decoded.slice(0, 21)
  const checksum = decoded.slice(21)

  const hash = CryptoJS.SHA256(
    CryptoJS.SHA256(toWordArray(payload))
  ).words[0]

  return (
    checksum[0] === ((hash >> 24) & 0xff) &&
    checksum[1] === ((hash >> 16) & 0xff) &&
    checksum[2] === ((hash >> 8) & 0xff) &&
    checksum[3] === (hash & 0xff)
  )
}

function validateTRC (address) {
  if (address.length !== 34) return false
  if (!address.startsWith('T')) return false
  if (!BASE58_REGEX.test(address)) return false

  let decoded

  try {
    decoded = base58Decode(address)
  } catch (e) {
    return false
  }

  // structure
  // version (1) + address (20) + checksum (4)
  if (decoded.length !== 25) return false
  // TRON mainnet version byte
  if (decoded[0] !== TRON_VERSION) return false

  // checksum
  return isValidChecksum(decoded)
}

export function validateEmail (email) {
  const reg = new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?')
  return reg.test(email)
}

export function validateAccountId (accountId) {
  return Keypair.isValidPublicKey(accountId)
}



// WEBPACK FOOTER //
// ./src/validator/validator.js